// extracted by mini-css-extract-plugin
export default {"headerMain":"Header_headerMain__bh4ws","exit":"Header_exit__71gXN","exitText":"Header_exitText__yxJK1"};